<template>
    <div>
        <el-row class="main">
            <div class="card-box">
                <!-- 右边卡片 -->
                <div class="card-rb">
                    <div class="card-4">
                        <el-card>
                            <div>
                                <el-form
                                    :inline="true"
                                    class="demo-form-inline"
                                    size="mini"
                                    :model="searchlist"
                                >
                                    <el-form-item
                                        label="组织名称:"
                                        prop="title"
                                    >
                                        <el-input
                                            v-model="searchlist.orgName"
                                            placeholder="请输入组织名称"
                                        ></el-input>
                                    </el-form-item>
                                    <el-form-item label="负责人:" prop="title">
                                        <el-input
                                            v-model="searchlist.chargePerson"
                                            placeholder="请输入负责人"
                                        ></el-input>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button
                                            type="primary"
                                            @click="search"
                                            >查询</el-button
                                        >
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button
                                            type="info"
                                            @click="searchlistReset"
                                            >重置</el-button
                                        >
                                    </el-form-item>
                                </el-form>
                            </div>
                            <div class="three">
                                <el-button
                                    type="primary"
                                    size="mini"
                                    @click="addFunc()"
                                    >新增</el-button
                                >
                            </div>
                            <!-- 表格盒子 -->
                            <div class="table_card">
                                <el-table
                                    ref="singleTable"
                                    :data="tableData"
                                    highlight-current-row
                                    style="width: 100%; margin-top: 16px"
                                    border
                                >
                                    <el-table-column
                                        label="序号"
                                        type="index"
                                        align="center"
                                        width="50"
                                    ></el-table-column>
                                    <el-table-column
                                        label="组织名称"
                                        prop="orgName"
                                        align="center"
                                        :show-overflow-tooltip="true"
                                    ></el-table-column>
                                    <el-table-column
                                        label="负责人"
                                        prop="chargePerson"
                                        align="center"
                                        :show-overflow-tooltip="true"
                                    ></el-table-column>
                                    <el-table-column
                                        label="联系电话"
                                        align="center"
                                        prop="phone"
                                        :show-overflow-tooltip="true"
                                    ></el-table-column>
                                    <el-table-column
                                        label="服务类型"
                                        prop="serviceTypeName"
                                        align="center"
                                        :show-overflow-tooltip="true"
                                    ></el-table-column>
                                    <!-- <el-table-column label="组织介绍" prop="introduction" align="center" :show-overflow-tooltip="true" ></el-table-column> -->
                                    <el-table-column
                                        property="eight"
                                        label="招募状态"
                                        align="center"
                                        prop="recruitStatus"
                                        :show-overflow-tooltip="true"
                                    >
                                        <template scope="scope">
                                            <span
                                                v-if="
                                                    scope.row.recruitStatus ==
                                                    '0'
                                                "
                                                >未招募</span
                                            >
                                            <span
                                                v-if="
                                                    scope.row.recruitStatus ==
                                                    '1'
                                                "
                                                >招募中</span
                                            >
                                            <span
                                                v-if="
                                                    scope.row.recruitStatus ==
                                                    '2'
                                                "
                                                >招募结束</span
                                            >
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="operation"
                                        label="操作"
                                        align="center"
                                        width="250px"
                                    >
                                        <template slot-scope="scope">
                                            <el-tooltip
                                                class="item"
                                                effect="light"
                                                content="查看"
                                                placement="top-start"
                                            >
                                                <button
                                                    style="color: skyblue"
                                                    class="iconfont icon-chakan tabBtn"
                                                    @click="
                                                        look(
                                                            scope.row.id,
                                                            'look'
                                                        )
                                                    "
                                                ></button>
                                            </el-tooltip>
                                            <el-tooltip
                                                class="item"
                                                effect="light"
                                                content="修改"
                                                placement="top-start"
                                            >
                                                <button
                                                    class="iconfont icon-bianji3 tabBtn"
                                                    style="color: #2e99cf"
                                                    @click="
                                                        look(
                                                            scope.row.id,
                                                            'edit'
                                                        )
                                                    "
                                                ></button>
                                            </el-tooltip>
                                            <el-tooltip
                                                class="item"
                                                effect="light"
                                                content="招募"
                                                placement="top-start"
                                            >
                                                <button
                                                    v-if="
                                                        scope.row
                                                            .recruitStatus ==
                                                            undefined ||
                                                        scope.row
                                                            .recruitStatus ==
                                                            null
                                                    "
                                                    style="color: #ff04ed"
                                                    class="iconfont el-icon-circle-plus-outline tabBtn"
                                                    @click="
                                                        look(
                                                            scope.row.id,
                                                            'recruit'
                                                        )
                                                    "
                                                ></button>
                                            </el-tooltip>
                                            <el-tooltip
                                                class="item"
                                                effect="light"
                                                content="删除"
                                                placement="top-start"
                                            >
                                                <button
                                                    style="color: red"
                                                    class="iconfont icon-icon7 tabBtn"
                                                    @click="
                                                        deleteDislog(
                                                            scope.row.id
                                                        )
                                                    "
                                                ></button>
                                            </el-tooltip>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <el-pagination
                                    style="margin-top: 10px"
                                    @current-change="handleCurrentChange"
                                    :current-page="pageConfig.pageNo"
                                    :page-size="10"
                                    layout="total, prev, pager, next, jumper"
                                    :total="pageConfig.total"
                                ></el-pagination>
                            </div>
                        </el-card>
                    </div>
                </div>
                <!--    新增弹框-->
                <el-dialog
                    :title="dialogTitle"
                    :visible.sync="addDialogFormVisible"
                    width="955px"
                    @close="clearForm()"
                >
                    <el-form
                        :model="addform"
                        ref="addform"
                        :rules="rules"
                        :label-position="labelPosition"
                        label-width="180px"
                    >
                        <el-form-item label="组织名称：">
                            <el-input
                                class="form_input"
                                :disabled="readonly"
                                v-model="addform.orgName"
                                placeholder="请输入"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="负责人：">
                            <el-input
                                class="form_input"
                                :disabled="readonly"
                                v-model="addform.chargePerson"
                                placeholder="请输入"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="联系电话：" prop="phone">
                            <el-input
                                class="form_input"
                                :disabled="readonly"
                                v-model="addform.phone"
                                placeholder="请输入"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="组织介绍：">
                            <el-input
                                class="form_input"
                                :disabled="readonly"
                                v-model="addform.introduction"
                                type="textarea"
                                :row="4"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="服务日期：">
                            <el-checkbox-group
                                v-model="dateList"
                                class="form_input"
                            >
                                <el-checkbox :disabled="readonly" label="0"
                                    >周一</el-checkbox
                                >
                                <el-checkbox :disabled="readonly" label="1"
                                    >周二</el-checkbox
                                >
                                <el-checkbox :disabled="readonly" label="2"
                                    >周三</el-checkbox
                                >
                                <el-checkbox :disabled="readonly" label="3"
                                    >周四</el-checkbox
                                >
                                <el-checkbox :disabled="readonly" label="4"
                                    >周五</el-checkbox
                                >
                                <el-checkbox :disabled="readonly" label="5"
                                    >周六</el-checkbox
                                >
                                <el-checkbox :disabled="readonly" label="6"
                                    >周末</el-checkbox
                                >
                            </el-checkbox-group>
                        </el-form-item>
                        <el-form-item label="服务时间：">
                            <el-checkbox-group
                                v-model="timekList"
                                class="form_input"
                            >
                                <el-checkbox :disabled="readonly" label="0"
                                    >上午</el-checkbox
                                >
                                <el-checkbox :disabled="readonly" label="1"
                                    >下午</el-checkbox
                                >
                            </el-checkbox-group>
                        </el-form-item>
                        <el-form-item label="服务类型：">
                            <el-checkbox-group
                                v-model="checkList"
                                class="form_input"
                            >
                                <el-checkbox :disabled="readonly" label="0"
                                    >为老服务类</el-checkbox
                                >
                                <el-checkbox :disabled="readonly" label="1"
                                    >助残服务类</el-checkbox
                                >
                                <el-checkbox :disabled="readonly" label="2"
                                    >青少年服务类</el-checkbox
                                >
                                <el-checkbox :disabled="readonly" label="3"
                                    >救助帮困类</el-checkbox
                                >
                                <el-checkbox :disabled="readonly" label="4"
                                    >其它公益类</el-checkbox
                                >
                            </el-checkbox-group>
                        </el-form-item>
                        <el-form-item label="选择组织成员">
                            <el-button
                                :disabled="readonly"
                                type="primary"
                                size="mini"
                                @click="getmenberList()"
                                >添加组织成员
                            </el-button>
                        </el-form-item>
                        <el-form-item label="组织成员">
                            <el-table
                                class="form_input"
                                :data="member"
                                ref="multipleTable"
                                :header-cell-style="{ background: '#f8fafa' }"
                                border
                                align="center"
                                current-row-key
                                highlight-current-row
                            >
                                <el-table-column
                                    type="index"
                                    align="center"
                                    label="序号"
                                    width="50"
                                ></el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="name"
                                    label="姓名"
                                ></el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="post"
                                    label="职位"
                                >
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.post == 0"
                                            >党委书记</span
                                        >
                                        <span v-if="scope.row.post == 1"
                                            >党委副书记</span
                                        >
                                        <span v-if="scope.row.post == 2"
                                            >记检委员</span
                                        >
                                        <span v-if="scope.row.post == 3"
                                            >组织委员</span
                                        >
                                        <span v-if="scope.row.post == 4"
                                            >其他委员</span
                                        >
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="sort"
                                    label="排序"
                                ></el-table-column>
                                <el-table-column
                                    align="center"
                                    fixed="right"
                                    label="操作"
                                    width="150"
                                >
                                    <template slot-scope="scope">
                                        <el-button
                                            :disabled="readonly"
                                            @click="lookdata(scope.row, 'look')"
                                            type="text"
                                            size="small"
                                            >查看</el-button
                                        >
                                        <el-button
                                            :disabled="readonly"
                                            @click="lookdata(scope.row, 'edit')"
                                            type="text"
                                            size="small"
                                            >编辑</el-button
                                        >
                                        <!-- <el-button :disabled="readonly"  @click="deletdata(scope.$index,'delet')" type="text" size="small">删除</el-button> -->
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-form-item>
                        <el-dialog
                            title="完善人员信息"
                            :visible.sync="dialogPersonInfo"
                            width="955px"
                            :before-close="handleClose"
                            append-to-body
                        >
                            <el-form
                                :model="ruleForm"
                                status-icon
                                ref="ruleForm"
                                label-width="150px"
                                class="demo-ruleForm"
                            >
                                <el-form-item label="姓名：">
                                    <el-input
                                        disabled
                                        class="winput450"
                                        v-model="ruleForm.name"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="职位：">
                                    <el-select
                                        class="winput450"
                                        v-model="ruleForm.post"
                                    >
                                        <el-option
                                            label="党委书记"
                                            value="0"
                                        ></el-option>
                                        <el-option
                                            label="党委副书记"
                                            value="1"
                                        ></el-option>
                                        <el-option
                                            label="记检委员"
                                            value="2"
                                        ></el-option>
                                        <el-option
                                            label="组织委员"
                                            value="3"
                                        ></el-option>
                                        <el-option
                                            label="其他委员"
                                            value="4"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="排序：">
                                    <el-input
                                        type="number"
                                        :disabled="diabletwo"
                                        class="winput450"
                                        v-model="ruleForm.sort"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="图片：" prop="photo">
                                    <div class="threestyleimg">
                                        <div class="threestyleimgtu">
                                            <img
                                                :src="ruleForm.photo"
                                                alt
                                                style="
                                                    width: 170px;
                                                    height: 150px;
                                                "
                                            />
                                        </div>
                                        <div class="threestyleimgbtn">
                                            <div>上传照片</div>
                                            <input
                                                type="file"
                                                @change="upimg"
                                            />
                                            <!-- <el-button @click="deleteImg">删除</el-button> -->
                                        </div>
                                        <div class="el-upload__tip" slot="tip">
                                            友情提示:只能上传一个照片,且照片大小不能超过10M
                                        </div>
                                    </div>
                                </el-form-item>
                            </el-form>
                            <div slot="footer" class="dialog-footer clacenter">
                                <el-button @click="closeMember()"
                                    >取 消</el-button
                                >
                                <el-button type="primary" @click="editMember()"
                                    >确 定</el-button
                                >
                            </div>
                        </el-dialog>
                        <el-form-item
                            label="组织地址："
                            style="margin-top: 20px"
                        >
                            <div
                                class="form_input"
                                style="
                                    display: flex;
                                    justify-content: space-between;
                                    margin-bottom: 15px;
                                "
                            >
                                <el-select
                                    class="addres_input"
                                    :disabled="readonly"
                                    v-model="addform.province"
                                    style="margin-right: 20px"
                                    placeholder="请选择"
                                >
                                    <el-option
                                        label="绩溪街道"
                                        :value="1"
                                    ></el-option>
                                </el-select>
                                <el-select
                                    class="addres_input"
                                    :disabled="readonly"
                                    style="margin-right: 20px"
                                    @change="getAddressByParentId"
                                    v-model="addform.city"
                                    placeholder="请选择"
                                >
                                    <el-option
                                        label="来苏社区"
                                        :value="2"
                                    ></el-option>
                                </el-select>
                                <el-select
                                    class="addres_input"
                                    :disabled="readonly"
                                    v-model="areaId"
                                    @change="changeArea"
                                    placeholder="选择网格"
                                    style="width: 174px"
                                >
                                    <el-option
                                        v-for="item in gridCode"
                                        :key="item.id"
                                        :label="item.orgName"
                                        :value="item.id"
                                    ></el-option>
                                </el-select>
                            </div>
                            <div style="display: flex; margin-bottom: 15px">
                                <el-input
                                    class="form_input"
                                    :disabled="readonly"
                                    v-model="addform.address"
                                    @blur="transLocation"
                                ></el-input>
                            </div>
                            <div style="display: flex; margin-bottom: 15px">
                                <div
                                    id="container"
                                    class="form_input"
                                    style="height: 200px; margin-bottom: 30px"
                                ></div>
                            </div>
                        </el-form-item>
                        <el-form-item label="上传图片：">
                            <el-upload
                                :class="{ hide: hideUpload }"
                                :disabled="readonly"
                                :action="url"
                                list-type="picture-card"
                                :on-preview="handlePictureCardPreview2"
                                :on-success="imgok"
                                :file-list="fileListimg"
                                :on-remove="handleRemove2"
                            >
                                <i class="el-icon-plus"></i>
                            </el-upload>
                            <el-dialog
                                :visible.sync="dialogVisible1"
                                append-to-body
                            >
                                <img width="100%" :src="dialogImageUrl" alt />
                            </el-dialog>
                        </el-form-item>
                        <el-form-item label="状态">
                            <el-radio-group
                                :disabled="readonly"
                                v-model="addform.status"
                            >
                                <el-radio label="0">启用</el-radio>
                                <el-radio label="1">禁用</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <div v-if="zhaomusend == true" style="margin-top: 30px">
                            <el-form-item label="招募时间：">
                                <el-date-picker
                                    class="form_input"
                                    :disabled="auditreadonly"
                                    v-model="recruitTimeses"
                                    type="datetimerange"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                ></el-date-picker>
                            </el-form-item>
                            <el-form-item label="加入条件：">
                                <el-input
                                    class="form_input"
                                    v-model="addform.joinCondition"
                                    :autosize="{ minRows: 2 }"
                                    :disabled="auditreadonly"
                                    type="textarea"
                                    placeholder="请填写此项"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="招募说明：">
                                <el-input
                                    class="form_input"
                                    v-model="addform.recruitInstructions"
                                    :autosize="{ minRows: 2 }"
                                    :disabled="auditreadonly"
                                    type="textarea"
                                    placeholder="请填写此项"
                                ></el-input>
                            </el-form-item>
                        </div>
                        <el-form-item>
                            <div class="footer">
                                <el-button
                                    v-if="addsend == true"
                                    type="primary"
                                    @click="addSave()"
                                    >确 定</el-button
                                >
                                <el-button
                                    v-if="auditsendan == true"
                                    type="primary"
                                    @click="shenheSave()"
                                    >招 募</el-button
                                >
                                <el-button
                                    v-if="editsend == true"
                                    type="primary"
                                    @click="editSave()"
                                    >修 改</el-button
                                >
                                <el-button type="info" @click="clearForm()"
                                    >取 消</el-button
                                >
                            </div>
                        </el-form-item>
                    </el-form>
                </el-dialog>
                <el-dialog
                    title="选择人员"
                    :visible.sync="dialogPeopleVisible"
                    width="50%"
                    :before-close="handleClose"
                    append-to-body
                >
                    <el-form
                        :inline="true"
                        :model="searchPeopleList"
                        class="demo-form-inline"
                        size="mini"
                    >
                        <el-form-item
                            label="人员姓名:"
                            style="margin: 0 30px 0 0"
                        >
                            <el-input
                                v-model="searchPeopleList.name"
                                placeholder="请输入人员姓名"
                            ></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="getrenyuaInfo"
                                >查询</el-button
                            >
                        </el-form-item>
                        <el-form-item>
                            <el-button type="info" @click="searchPeopleReset"
                                >重置</el-button
                            >
                        </el-form-item>
                        <el-form-item></el-form-item>
                    </el-form>
                    <el-table
                        :data="menberTableData"
                        ref="multipleTable"
                        :header-cell-style="{ background: '#f8fafa' }"
                        border
                        align="center"
                        @selection-change="handleSelectionChange"
                        current-row-key
                        highlight-current-row
                        :row-key="getRowKey"
                    >
                        <el-table-column
                            type="selection"
                            :reserve-selection="true"
                            align="center"
                        ></el-table-column>
                        <el-table-column
                            type="index"
                            align="center"
                            label="序号"
                            width="50"
                        ></el-table-column>
                        <el-table-column
                            align="center"
                            prop="name"
                            width="180"
                            label="姓名"
                            :show-overflow-tooltip="true"
                        ></el-table-column>
                        <el-table-column
                            align="center"
                            prop="sex"
                            width="100"
                            label="性别"
                        >
                            <template slot-scope="scope">
                                <span v-if="scope.row.sex == 1">女</span>
                                <span v-if="scope.row.sex == 0">男</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            align="center"
                            prop="socialOrgName"
                            label="所属社会组织"
                            :show-overflow-tooltip="true"
                        ></el-table-column>
                    </el-table>
                    <el-pagination
                        style="margin-top: 10px"
                        @current-change="handleChange"
                        :current-page="pageConfig.pageNo"
                        :page-size="5"
                        layout="total, prev, pager, next, jumper"
                        :total="pageConfig.total"
                    ></el-pagination>
                    <div slot="footer" class="dialog-footer clacenter">
                        <el-button @click="dialogPeopleVisible = false"
                            >取 消</el-button
                        >
                        <el-button type="primary" @click="addMember()"
                            >确 定</el-button
                        >
                    </div>
                </el-dialog>
            </div>
        </el-row>
    </div>
</template>

<script>
import { uploadPartyPhoto } from "@/api/http"
import { post } from "@/api/requrestHttp.js"
import baseURL from "@/api/baseURL"
import AMap from "AMap" // 引入高德地图
export default {
    data() {
        return {
            hideUpload: false,
            zhaomusend: false,
            auditreadonly: false,
            dialogPersonInfo: false,
            menberTableData: [],
            ruleForm: [],
            member: [],
            startTime: "",
            endTime: "",
            recruitTimeses: [],
            searchPeopleList: {},
            diabletwo: false,
            eddimgurl: require("@/assets/images/partyMemberManagementcopy/imgjia.png"),
            dialogPeopleVisible: false,
            dialogLoading: false,
            url:baseURL+
                "/ypt/controller/uploadVotePic/info/uploadPartyPhoto",
            dialogImageUrl: "", //图片上传,
            dialogVisible1: false, // 上传模态框按钮
            fileListimg: [],
            dialogTitle: "新增",
            labelPosition: "right",
            gridCode: [],
            areaId: "",
            radio: "",
            addsend: false,
            editsend: false,
            auditsend: false,
            auditsendan: false,
            checked: true,
            addDialogFormVisible: false,
            photoDialogVisible: false,
            checkList: [],
            dateList: [],
            timekList: [],
            dialogImageUrl: "",
            addform: {
                serviceType: "",
                approvalStatus: 0,
                source: 0,
            },
            rules: {
                // name: [{ required: true, message: "请输入姓名", trigger: "blur" , trigger: "blur",}],
                // sex: [{ required: true, message: "请选择性别", trigger: "blur" , trigger: "blur",}],
                phone: [
                    {
                        required: true,
                        message: "请输入手机号码",
                        trigger: "blur",
                    },
                    {
                        validator: function (rule, value, callback) {
                            if (/^1[34578]\d{9}$/.test(value) == false) {
                                callback(new Error("请输入正确的手机号"))
                            } else {
                                callback()
                            }
                        },
                        trigger: "blur",
                    },
                ],
                idCode: [
                    {
                        required: true,
                        message: "请输入身份证号",
                        trigger: "blur",
                    },
                    {
                        pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
                        message: "你的身份证格式不正确",
                    },
                ],
                // photo: [{ required: false, message: "请上传照片", trigger: "blur" }],
                // communityPerson: [{ required: true, message: "请选择是否是社区工作人员", trigger: "change", }],
                // status: [{ required: true, message: "请选择启动状态", trigger: "change", }],
            },
            searchlist: {},
            lookform: {},
            editform: {},
            shenheform: {},
            imageUrl: "",
            options: [
                {
                    value: "选项1",
                    label: "未开始",
                },
                {
                    value: "选项2",
                    label: "报名中",
                },
                {
                    value: "选项3",
                    label: "蚵仔煎",
                },
                {
                    value: "选项4",
                    label: "已结束",
                },
                {
                    value: "选项5",
                    label: "已终止",
                },
            ],
            value: "",
            input: "",
            pickerOptions: {},
            readonly: false,
            value1: "",
            value2: "",
            addformTypeArr: [],
            multipleSelection: [],
            tableData: [],
            imgupdataimg: "",
            pageConfig: {
                pageNo: 1,
                pageSize: 10,
                total: 0,
            },
        }
    },
    methods: {
        // 选择关联产品：打勾或取消
        handleSelectionChange(selecteds) {
            console.log("selecteds", selecteds)
            this.multipleSelection = selecteds
        },
        //封装数据
        createData() {
            console.log(this.multipleSelection)
            this.tableData = this.multipleSelection
            this.checkpeopType = false
        },
        //问题二、数据回显问题
        getRowKey(row) {
            return row.id
        },

        //编辑成员信息
        editMember() {
            this.updataPersonImg()
            this.closeMember()
        },
        closeMember() {
            this.dialogPersonInfo = false
        },
        updataPersonImg() {
            console.log(this.imgupdata)
            post("/admin/socialWorker/info/updateSocialWorker", {
                id: this.imgupdata,
                photo: this.imgupdataimg,
            }).then((res) => {
                if (res.code == "200") {
                    console.log(res)
                }
            })
        },
        lookdata(data, type) {
            console.log(data)
            this.imgupdata = data.socialWokerId
            console.log(this.imgupdata)
            this.dialogPersonInfo = true
            this.ruleForm = data
            console.log(data.photo)
            this.eddimgurl = data.photo
            if (type == "look") {
                this.diabletwo = true
            } else if (type == "edit") {
                this.diabletwo = false
            }
        },
        getmenberList() {
            this.dialogPeopleVisible = true
            this.member = []
            this.multipleSelection = []
            this.getrenyuaInfo()
        },
        //成员
        addMember() {
            console.log(this.multipleSelection)
            var newdata = this.multipleSelection
            console.log(777, newdata)
            newdata.forEach((item) => {
                console.log(item.id)
                console.log(item.name)
                console.log(item.post)
                console.log(item.photo)
                this.member.push({
                    socialWokerId: item.id,
                    name: item.name,
                    post: item.post,
                    photo: item.photo,
                    sort: item.sort,
                })
            })
            console.log("this.member====", this.member)
            this.dialogPeopleVisible = false
        },
        getrenyuaInfo() {
            let parmes = {
                ...this.searchPeopleList,
                menuType: "personInformationBase",
                pageSize: 5,
                pageNo: this.pageConfig.pageNo,
                status: 0,
                approvalStatus: 1,
            }
            post("/admin/socialWorker/info/listSocialWorker", parmes)
                .then((res) => {
                    console.log(res)
                    if (res.code == 200) {
                        this.pageConfig.total = res.content.count
                        this.menberTableData = res.content.list
                        console.log(this.menberTableData)
                    } else {
                        console.log(res)
                        this.$message({
                            message: "数据加载异常：",
                            type: "error",
                        })
                    }
                    if (res.content.list.length) {
                        // 取出当前页数的选中table数据
                        let hadTableData = []
                        if (this.choosedata && this.choosedata.length) {
                            this.choosedata.forEach((row) => {
                                res.content.list.forEach((row1) => {
                                    if (row.id == row1.id) {
                                        //   this.checkedData.push(row1);
                                        hadTableData.push(row1)
                                    }
                                })
                            })
                        }

                        // this.multipleSelectionFarher[this.pageConfig.pageNo] = hadTableData;
                        // //   第一次显示父级传进来的数据的回显,如果有选中则以实际为准
                        // //   console.log(this.multipleSelectionClick[this.pageConfig.pageNo]);
                        // if (!this.multipleSelectionClick[this.pageConfig.pageNo]) {
                        //   this.multipleSelection[this.pageConfig.pageNo] = hadTableData;
                        // }

                        // let newpagedata = [];
                        // res.content.list.forEach(row1 => {
                        //   this.multipleSelection[this.pageConfig.pageNo].forEach(row2 => {
                        //     if (row1.id == row2.id) {
                        //       //   this.checkedData.push(row1);
                        //       newpagedata.push(row1);
                        //     }
                        //   });
                        // });
                        // this.multipleSelection[this.pageConfig.pageNo] = newpagedata;
                        // this.checkedData = newpagedata;
                        // this.checkedTable();
                    }
                })
                .catch((e) => {})
        },
        searchPeopleReset() {
            this.searchPeopleList = {}
            this.getrenyuaInfo()
        },
        handleSelectionsChange(val) {
            this.multipleSelectionClick[this.pageConfig.pageNo] = val.length + 1
            this.multipleSelection[this.pageConfig.pageNo] = val
            console.log(this.multipleSelection[this.pageConfig.pageNo])
        },
        // 组织人员图片上传
        async upimg(e) {
            if (e.target.files[0] == undefined) {
                return false
            } else {
                let res = await uploadPartyPhoto(e.target.files[0])
                // this.ruleForm.eddimgurl = res.content;
                this.$set(this.ruleForm, "photo", res.content)
                this.imgupdataimg = res.content
                console.log(res.content)
            }
        },
        // 组织招募
        recruitFunc() {
            console.log(11)
        },
        //组织人员分页
        handleChange(val) {
            this.pageConfig.pageNo = val
            this.getrenyuaInfo()
        },
        // 分页
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`)
            this.pageConfig.pageNo = val
            this.getListSocialOrg()
        },
        // 点击新增
        addFunc() {
            this.addform = {}
            this.hideUpload = false
            this.addform.photo = []
            this.addsend = true
            this.editsend = false
            this.auditsend = false
            this.auditsendan = false
            this.readonly = false
            this.$nextTick(() => {
                setTimeout(() => {
                    this.mapInit("container")
                }, 500)
            })
            this.addDialogFormVisible = true
        },
        clearForm() {
            // 点击取消
            this.addDialogFormVisible = false
            this.addform = {}
            this.checkList = []
            this.dateList = []
            this.timekList = []
            this.fileListimg = []
            this.member = []
            this.areaId = ""
        },
        // 新增保存
        addSave() {
            this.$refs.addform.validate((valid) => {
                if (valid) {
                    this.checkList = this.checkList + ""
                    this.addform.serviceType = this.checkList
                    this.dateList = this.dateList + ""
                    this.addform.week = this.dateList
                    this.timekList = this.timekList + ""
                    this.addform.serviceTime = this.timekList
                    this.addDialogFormVisible = false
                    //循环拼接
                    var str = ""
                    if (Array.isArray(this.addform.photo)) {
                        this.addform.photo.map((item, index) => {
                            str += item + "#"
                        })
                    } else {
                        str = this.addform.photo
                    }
                    this.addform.leaders = this.member
                    console.log(this.member)
                    this.$set(this.addform, "photo", str)
                    post("/admin/socialOrg/info/insertSocialOrg", {
                        ...this.addform,
                        approvalStatus: 0,
                    }).then((res) => {
                        console.log(res)
                        this.getListSocialOrg()
                        this.clearForm()
                    })
                } else {
                    return false
                }
            })
        },
        // 查询
        search() {
            post("/admin/socialOrg/info/listSocialOrg", {
                ...this.searchlist,
                pageNo: this.pageConfig.pageNo,
                pageSize: this.pageConfig.pageSize,
            }).then((res) => {
                this.tableData = res.content.list
            })
        },
        handleClose(done) {
            done()
        },
        // 查询重置
        searchlistReset() {
            this.searchlist = {}
            this.getListSocialOrg()
        },
        // 获取列表
        getListSocialOrg() {
            post("/admin/socialOrg/info/listSocialOrg", {
                pageNo: this.pageConfig.pageNo,
                pageSize: this.pageConfig.pageSize,
            }).then((res) => {
                console.log(res)
                this.tableData = res.content.list
                this.pageConfig.total = res.content.count
            })
        },
        // 点击查看
        lookDialog(id) {
            this.lookDialogFormVisible = true
            post("/admin/socialOrg/info/getSocialOrg", {
                id: id,
            }).then((res) => {
                this.lookform = res.content
                this.checkList = res.content.serviceType.split(",")
                this.dateList = res.content.week.split(",")
                this.timekList = res.content.serviceTime.split(",")
            })
        },
        deletdata(index) {
            console.log(index)
            this.member.splice(index, 1)
            //表格数据删除后对话框前的勾选也删除
        },
        // 点击修改
        look(id, type) {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.mapInit("container")
                }, 500)
            })
            this.addDialogFormVisible = true
            this.recruitTimeses = []
            if (type == "look") {
                this.dialogTitle = "查看"
                this.readonly = true
                this.addsend = false
                this.editsend = false
                this.auditsendan = false
                this.zhaomusend = true
                this.auditreadonly = true
            } else if (type == "recruit") {
                this.dialogTitle = "招募"
                this.readonly = true
                this.addsend = false
                this.editsend = false
                this.auditsendan = true
                this.zhaomusend = true
                this.auditreadonly = false
            } else if (type == "edit") {
                this.dialogTitle = "修改"
                this.readonly = false
                this.addsend = false
                this.editsend = true
                this.zhaomusend = false
                this.auditsendan = false
            }
            post("/admin/socialOrg/info/getSocialOrg", {
                id: id,
            }).then((res) => {
                console.log(res)
                this.member = res.content.leaders
                this.addform = res.content
                console.log(33636, this.activityTimeses)
                this.areaId = res.content.areaName
                this.recruitTimeses.push(
                    res.content.startRecruitTime,
                    res.content.endRecruitTime
                )
                console.log(
                    res.content.startRecruitTime,
                    res.content.endRecruitTime
                )
                console.log(
                    res.content.startRecruitTime,
                    res.content.endRecruitTime
                )
                if (res.content.serviceType) {
                    this.checkList = res.content.serviceType.split(",")
                }
                if (res.content.week) {
                    this.dateList = res.content.week.split(",")
                }
                if (res.content.serviceTime) {
                    this.timekList = res.content.serviceTime.split(",")
                }

                console.log(333, this.checkList)
                if (this.addform.photo) {
                    this.addform.photo = res.content.photo.split("#")
                    this.addform.photo.map((item1, index) => {
                        if (item1 == "") {
                            this.addform.photo.splice(index, 1)
                        }
                    })
                    console.log(this.addform.photo)
                    this.fileListimg = []
                    this.addform.photo.map((item) => {
                        this.fileListimg.push({
                            url: item,
                        })
                    })
                    console.log(this.fileListimg)
                }
                this.checkList = res.content.serviceType.split(",")
                this.dateList = res.content.week.split(",")
                this.timekList = res.content.serviceTime.split(",")
                console.log(this.checkList)
            })
        },
        //上传图片方法
        handleRemove2(file, fileList) {
            this.addform.photo.map((item, index) => {
                if (file.response != undefined) {
                    if (item == file.response.content) {
                        this.addform.photo.splice(index, 1)
                    }
                } else {
                    if (item == file.url) {
                        this.addform.photo.splice(index, 1)
                    }
                }
                this.hideUpload = false
                console.log(this.addform.photo)
                if (this.addform.photo.length > 0) {
                    this.hideUpload = true
                }
            })
        },
        handlePictureCardPreview2(file) {
            this.hideUpload = false
            console.log(file)
            if (file) {
                this.hideUpload = true
            }
            this.dialogImageUrl = file.url
            this.dialogVisible1 = true
        },
        imgok: function (data, data1, data2) {
            this.hideUpload = false
            console.log(data)
            if (data.content != "") {
                this.hideUpload = true
            }
            if (data.code == 200) {
                this.fileListimg.push(data.content)
                this.addform.photo = this.fileListimg
                console.log(this.addform.photo)
            }
        },
        //改变状态
        async changeStatus(cdata) {
            let params = cdata
            console.log(params)
            post("/admin/socialOrg/info/updateSocialOrg", params).then(
                (res) => {
                    console.log(res)
                    var msg = "状态"
                    msg = msg + (cdata.status == "0" ? "启用" : "禁用")
                    if (res.code == 200) {
                        this.$message({
                            message: msg + "成功",
                            type: "success",
                        })
                    } else {
                        console.log(res.message)
                        this.$message({
                            message: msg + "失败",
                            type: "error",
                        })
                    }
                }
            )
        },
        // 修改保存
        editSave(id) {
            this.$refs.addform.validate((valid) => {
                if (valid) {
                    //图片循环拼接
                    console.log(this.addform.photo)
                    var str = ""
                    if (Array.isArray(this.addform.photo)) {
                        this.addform.photo.map((item, index) => {
                            str += item + "#"
                        })
                    } else {
                        str = this.addform.photo
                    }
                    this.$set(this.addform, "photo", str)
                    // 人员列表
                    this.addform.leaders = this.member
                    console.log(this.member)
                    // 服务类型
                    this.checkList = this.checkList + ""
                    this.addform.serviceType = this.checkList
                    this.dateList = this.dateList + ""
                    this.addform.week = this.dateList
                    this.timekList = this.timekList + ""
                    this.addform.serviceTime = this.timekList
                    console.log("参数", id + this.addform)
                    post("/admin/socialOrg/info/updateSocialOrg", {
                        id: id,
                        ...this.addform,
                    }).then((res) => {
                        if (res.code == 200) {
                            this.$message({
                                message: res.message,
                                type: "success",
                            })
                        }
                        this.addDialogFormVisible = false
                        this.getListSocialOrg()
                        this.clearForm()
                    })
                } else {
                    return false
                }
            })
        },
        // 删除
        deleteDislog(id) {
            this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$message({
                        type: "success",
                        message: "删除成功",
                    })
                    post("/admin/socialOrg/info/deleteSocialOrg", {
                        id: id,
                    }).then((res) => {
                        this.getListSocialOrg()
                    })
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    })
                })
        },
        //根据输入地址转换经纬度并标记
        transLocation() {
            var searchKey = this.addform.address
            var map = new AMap.Map("container", {
                resizeEnable: true,
                zoom: 18,
            })
            var that = this
            AMap.plugin("AMap.Geocoder", function () {
                var geocoder = new AMap.Geocoder({
                    radius: 1000,
                    extensions: "all",
                })
                var marker = new AMap.Marker()
                geocoder.getLocation(searchKey, function (status, result) {
                    if (status === "complete" && result.geocodes.length) {
                        var lnglat = result.geocodes[0].location
                        that.addform.longitude = String(lnglat.lng)
                        that.addform.latitude = String(lnglat.lat)
                        console.log("that.addform=>", that.addform)
                        marker.setPosition(lnglat)
                        map.add(marker)
                        map.setFitView(marker)
                    } else {
                        that.$message({
                            message: "获取坐标失败，请手动获取",
                            type: "error",
                        })
                        that.mapInit("container")
                    }
                })
                map.on("click", function (e) {
                    that.addform.longitude = String(e.lnglat.getLng())
                    that.addform.latitude = String(e.lnglat.getLat())
                    geocoder.getAddress(
                        e.lnglat.getLng() + "," + e.lnglat.getLat(),
                        function (status, result) {
                            console.log(status)
                            if (status === "complete" && result.regeocode) {
                                var address = result.regeocode.formattedAddress
                                that.$set(that.addform, "address", address)
                            } else {
                                log.error("根据经纬度查询地址失败")
                            }
                        }
                    )
                })
            })
        },
        //初始化地图插件的方法
        mapInit(containerId) {
            console.log("containerId", containerId)
            var map = new AMap.Map(containerId, {
                resizeEnable: true,
                zoom: 18,
                zooms: [3, 20],
                expandZoomRange: true,
                center: [118.009229, 32.790228],
            })
            console.log(map)
            if (this.addform.longitude && this.addform.latitude) {
                var marker = new AMap.Marker({
                    position: [
                        Number(this.addform.longitude),
                        Number(this.addform.latitude),
                    ],
                    map: map,
                })
                map.setFitView(marker)
            } else {
                AMap.plugin("AMap.Geolocation", function () {
                    //异步定位当前
                    var geolocation = new AMap.Geolocation()
                    map.addControl(geolocation)
                })
            } //定义地图坐标点击事件
            var that = this
            var geocoder = new AMap.Geocoder({
                city: "010", //城市设为北京，默认：“全国”
                radius: 1000, //范围，默认：500
            })
            map.on("click", function (e) {
                that.addform.longitude = String(e.lnglat.getLng())
                that.addform.latitude = String(e.lnglat.getLat())
                geocoder.getAddress(
                    e.lnglat.getLng() + "," + e.lnglat.getLat(),
                    function (status, result) {
                        console.log(status)
                        if (status === "complete" && result.regeocode) {
                            var address = result.regeocode.formattedAddress
                            that.$set(that.addform, "address", address)
                        } else {
                            log.error("根据经纬度查询地址失败")
                        }
                    }
                )
            })
        },

        // 获取地址下拉
        getAddressByParentId(addId) {
            this.gridCode = []
            this.areaId = ""
            post("/admin/org/info/findOrgGrid", {
                parentId: "2",
            }).then((res) => {
                console.log(res.content)
                this.gridCode = res.content.list
            })
        },
        changeArea(val) {
            console.log(val)
            this.addform.area = val
            console.log("this.addform.area", this.addform.area)
        },
        // 审核
        shenheDialog(id) {
            this.shenheid = id
            this.shenhedialogFormVisibleTwo = true
            post("/admin/socialOrg/info/getSocialOrg", {
                id: id,
            }).then((res) => {
                this.shenheform = res.content
            })
        },
        // 审核保存
        shenheSave() {
            console.log(this.addform.id)
            post("/admin/socialOrg/info/recruitSocialOrg", {
                id: this.addform.id,
                joinCondition: this.addform.joinCondition,
                recruitInstructions: this.addform.recruitInstructions,
                startRecruitTime: this.recruitTimeses[0],
                endRecruitTime: this.recruitTimeses[1],
            }).then((res) => {
                this.getListSocialOrg()
                this.addDialogFormVisible = false
                this.clearForm()
            })
        },
        handleAvatarSuccess(file, fileList) {
            console.log(file.content)
            this.addform.photo = file.content
            this.lookform.photo = file.content
            this.editform.photo = file.content
            this.shenform.photo = file.content
            console.log(this.addform.photo)
            console.log(fileList)
        },
    },
    mounted() {
        this.getListSocialOrg()
        this.getAddressByParentId()
    },
}
</script>

<style lang="less" scoped>
.dialog-footer {
    display: flex;
    justify-content: center;
}
.main {
    width: 100%;
    height: 100%;
    position: relative;
}
/deep/.tabBtn {
    font-size: 18px;
}
.form_input {
    width: 600px;
}
.el-form-item {
    margin-top: 20px;
}
.footer {
    text-align: center;
    margin-left: -140px;
}
.winput450 {
    width: 450px;
}
.threestyleimgbtn {
    width: 80%;
    height: 30%;
    margin-top: 20px;

    // background-color: green;
    display: flex;
    // justify-content: center;
    // align-items: center;

    position: relative;
    div {
        width: 170px;
        height: 30%;
        background: #ffffff;
        border: 1px solid #cad4dc;
        text-align: center;
        line-height: 30px;
    }
    input {
        position: absolute;
        width: 172px;
        height: 32px;
        opacity: 0;
        cursor: pointer;
    }
}
.hide {
    /deep/.el-upload--picture-card {
        display: none;
    }
}
</style> 